import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  return getRequest(
    `postalCode/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`,
  )
}

export async function searchCode(id) {
  return getRequest(`getStartsWithCodes/get-startswith/${id}`)
}

export async function find(id) {
  return getRequest(`postalCode/edit/${id}`)
}

export async function save(values) {
  return postRequest(`postalCode/save`, values)
}

export function remove(values) {
  return postRequest(`postalCode/delete`, values)
}
